module.exports = __webpack_public_path__ + "static/media/02BMCAmuralprep.d7d475dd.webp";